import { Button, makeStyles, Tooltip } from '@material-ui/core';
import React from 'react';

import type ICoProducer from 'interfaces/ICoProducer';

const styles = makeStyles(() => ({
  statusContent: {
    color: '#192542',
    fontSize: '0.775rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    cursor: 'help',
  },

  status: {
    fontWeight: 450,
    '&.Aprovado': {
      color: '#009358',
    },
    '&.Pendente': {
      color: '#37474F',
    },
    '&.Reprovado': {
      color: '#dc3f53',
    },
  },
}));

export const PartnerStatus = ({ cop }: { cop: ICoProducer }) => {
  const classes = styles();
  if (cop.pending && cop.action !== 'remove') return null;
  let action = 'Ativo';
  if (cop.new || !cop.customer_id) action = 'Novo';
  if (!cop.new && cop.edited) action = 'Parceiro será modificado';
  if (cop.pending && cop.action === 'remove') action = 'Parceiro será removido';
  return (
    <Tooltip title={<PartnerStatusTip />} placement='top'>
      <Button className={classes.statusContent}>
        <strong>{action}</strong>
      </Button>
    </Tooltip>
  );
};

export const ApprobationStatus = ({ cop }: { cop: ICoProducer }) => {
  const classes = styles();
  return (
    <Tooltip title={<ApprobationStatusTip />} placement='top'>
      <Button className={classes.statusContent}>
        <span className={`${classes.status} ${cop.status}`}>{cop.status}</span>
      </Button>
    </Tooltip>
  );
};

const PartnerStatusTip = () => (
  <>
    <p>Status do parceiro</p>
    <p>Ativo: parceiro está ativo no produto</p>
    <p>Novo: novo parceiro que será adicionado a uma nova configuração de parceiros</p>
    <p>Modificado: parceiro será modificado na nova configuração</p>
    <p>Removido: parceiro será removido dos parceiros do produto na nova configuração</p>
  </>
);

const ApprobationStatusTip = () => (
  <>
    <p>Status de aprovação</p>
    <p>Pendente: aguardando moderação do parceiro</p>
    <p>Aprovado: parceiro aprovou modificação/remoção</p>
    <p>Reprovado: parceiro recusou modificação/remoção</p>
  </>
);
